<template>
	<sf-data-table
		ref="dataTable"
		paging
		selection
		creatable
		editable
		:columns="columns"
		:rows="rows"
		:totalSize="groups.totalSize"
		:currentPage="groups.currentPage"
		:pageUnit="groups.pageUnit"
		:pageArray="screen.pageArray"
		:addRowData="addRowData"
		:saveFunc="saveFunc"
		@changedPage="changedPage"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'permGrpCd'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-input v-model="slotProps.row[slotProps.column.property]" maxlength="5" />
				</template>
				<template v-else>
					{{ slotProps.row.permGrpCd }}
				</template>
			</template>
		</template>

		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plus" :onClick="addAction">
				{{ getMessage_('SWCC000007') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('SWCC000327') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CD')" line icon="trash" color="error" :onClick="deleteAction">
				{{ getMessage_('SWCC000328') }}
			</sf-button>
			<!-- <sf-button line icon="trash" color="error" v-if="isButton_(scrId,'CD')" :onClick="deleteAction">{{ getButtonMsg_(scrId,'CD') }}</sf-button> -->
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupManagement/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		schema() {
			return yup.array().of(
				yup.object().shape({
					userGrpName: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000105')])), //{0}은(는) 필수 입력 값 입니다.
					permGrpCd: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000104')])) //{0}은(는) 필수 입력 값 입니다.
				})
			);
		},
		rows() {
			return this.resultList;
		},
		columns() {
			return [
				// {
				// 	label: this.getMessage_('SWCC000141'),
				// 	prop: 'tableState',
				// 	minWidth: '70px',
				// 	sortable: false
				// },
				{
					label: this.getMessage_('SWCC000104'),
					prop: 'permGrpCd',
					minWidth: '180px',
					form: {
						type: 'input',
						maxLength: 5,
						validation: {
							regExp: /^[A-Z0-9]*$/
						}
					}
				},
				{
					label: this.getMessage_('SWCC000105'),
					prop: 'userGrpName',
					minWidth: '180px',
					type: 'input',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('SWCC000106'),
					prop: 'useYn',
					minWidth: '120px',
					form: {
						type: 'select',
						options: this.gridUseYnList
					}
				},
				{
					label: this.getMessage_('SWCC000004'),
					prop: 'regDt',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000005'),
					prop: 'regId',
					minWidth: '150px',
					sortable: false
				}
			];
		}
	},
	data() {
		return {
			screen: {},
			addRowData: {
				state: 'I',
				rowType: 'add',
				permGrpCd: null,
				userGrpName: null,
				useYn: 'Y',
				useYnBk: 'Y'
			}
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return;
			}

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		addAction() {
			let addRowData = { ...this.addRowData };
			this.rows.unshift(addRowData);
			this.$refs.dataTable.getTable().toggleRowSelection(addRowData);

			this.addRowData.permGrpCd = null;
			this.addRowData.userGrpName = null;
		},
		saveAction() {
			const selected = this.$refs.dataTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},
		deleteAction() {
			const selected = this.$refs.dataTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				});
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000108'),
				buttons: [{ title: 'Ok', clickFn: () => this.delete(selected) }]
			});
		},
		delete() {
			let sendData = {
				status: 1,
				plantCd: this.searchParams.plantCd,
				data: []
			};

			const selected = this.$refs.dataTable.getSelectedRows();

			selected.forEach(row => {
				if (row.permGrpCd == null || row.permGrpCd.trim().length < 1) {
					let showMsg1 = this.getMessage_('SWCC000104');
					this.$sf_showMessage({
						title: this.getMessage_('SWCC000415'), // 입력 정보를 확인해주세요.
						message: this.$sf_formatString(this.getMessage_('SWCC000104'), [this.getMessage_('SWCC000105')])
					});

					return;
				}

				let pushSet = {
					permGrpCd: row.permGrpCd.trim(),
					userGrpName: row.userGrpName ? row.userGrpName : '',
					useYn: 'N',
					state: row.state
				};
				sendData.data.push(pushSet);
			});

			if (sendData.data != undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setGroups_(sendData)
					.then(header => {
						if (header.code === 0 || header.code === 3) {
							this.$sf_toast({
								type: header.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(header.messageCd)
							});
						} else if (header.code === 1) {
						} else if (header.code === 2) {
						} else if (header.code === 4) {
						} else if (header.code === 5) {
						}

						//this.resetTable();
					})
					.then(() =>
						this.getGroups_({
							searchParams: this.searchParams,
							currentPage: 1,
							pageUnit: this.groups.pageUnit
						})
					)
					.catch(e => {
						this.$sf_toast({
							type: 'error',
							message: e.message ? e.message : e
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		save(saveRows) {
			try {
				// 유효성 검사
				this.schema.validateSync(saveRows);

				let sendData = {
					status: 1,
					plantCd: this.searchParams.plantCd,
					data: []
				};

				const selected = this.$refs.dataTable.getSelectedRows();

				selected.forEach(row => {
					let pushSet = {
						permGrpCd: row.permGrpCd,
						userGrpName: row.userGrpName ? row.userGrpName : '',
						useYn: row.useYn ? row.useYn : 'Y',
						// regId: this.user.userId,
						// chgId: this.user.userId,
						state: row.state
					};
					sendData.data.push(pushSet);
				});

				if (sendData.data != undefined && sendData.data.length > 0) {
					// console.log('3');
					this.$sf_toggleLoading(true);
					this.setGroups_(sendData)
						.then(header => {
							if (header.code === 0 || header.code === 3) {
								this.$sf_toast({
									type: header.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(header.messageCd)
								});
							} else if (header.code === 1) {
							} else if (header.code === 2) {
							} else if (header.code === 4) {
							} else if (header.code === 5) {
							}

							this.resetTable();
						})
						.catch(e => {
							this.$sf_toast({
								type: 'error',
								message: e.message ? e.message : e
							});
							Promise.reject(error);
						})
						.finally(() => {
							this.$sf_toggleLoading(false);
						});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		saveFunc(saveRows) {
			//console.log(saveRows);
		},
		saveClick() {
			if (this.$refs.dataTable.multipleSelection.length < 1) {
				// title SWCC000110
				// message 저장 할 데이터를 선택해주세요.
				this.$sf_showMessage({ title: this.getMessage_('SWCC000110'), message: this.getMessage_('SWCC000434') });
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				message: this.getMessage_('SWCC000501'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		}
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);

		// this.userGroupManagementCols[3].options = this.gridUseYnList;
		this.columns[3].options = this.gridUseYnList;
	}
};
</script>

<style></style>
